import { render } from "./printOldToNewModel.vue?vue&type=template&id=69cde8f9"
import script from "./printOldToNewModel.vue?vue&type=script&lang=js"
export * from "./printOldToNewModel.vue?vue&type=script&lang=js"

import "./printOldToNewModel.vue?vue&type=style&index=0&id=69cde8f9&lang=scss"

import exportComponent from "D:\\companyProject\\G10Product\\trunk\\Bestech.CloudPos\\Bestech.CloudPos.Portal\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__